export default {
  minRange: {
    type: Number,
    label: 'sensors.configuration-dm2.min-range',
    precision: 2,
    maxLength: 14,
    minValue: -9999999999.99,
    maxValue: 9999999999.99,
  },
  maxRange: {
    type: Number,
    label: 'sensors.configuration-dm2.max-range',
    precision: 2,
    maxLength: 14,
    minValue: -9999999999.99,
    maxValue: 9999999999.99,
  },
  minCurrent: {
    type: Number,
    label: 'sensors.configuration-dm2.min-current',
    precision: 2,
    maxLength: 14,
    minValue: -9999999999.99,
    maxValue: 9999999999.99,
  },
  maxCurrent: {
    type: Number,
    label: 'sensors.configuration-dm2.max-current',
    precision: 2,
    maxLength: 14,
    minValue: -9999999999.99,
    maxValue: 9999999999.99,
  },
  value: {
    type: Number,
    label: 'sensors.configuration-dm2.modal.value',
    precision: 2,
    maxLength: 14,
  },
  measurementUnit: {
    type: String,
    label: 'sensors.configuration-dm2.modal.measuring-unit',
    maxLength: 10,
  },
  description: {
    type: String,
    label: 'sensors.configuration-dm2.description',
    maxLength: 100,
  },
};
